export default __webpack_public_path__ + "static/media/github.4728f0ad.svg";